import AreaGraph from './AreaGraph';

export default AreaGraph;
